// Librerie
import React from "react"
import { useTranslation } from "react-i18next";


interface WidgetPartnersProps {
    partners: { url: string, imgSrc: string, imgAlt: string }[];
}

export const WidgetPartners: React.FC<WidgetPartnersProps> = ({ partners }) => {

    const { t } = useTranslation();
    const countPartners = partners.length;

    return (
        <div className="widget-partners">
            <h3>{t('widgets.partners.title')}</h3>
            <ul className="list-unstyled mb-0 p-3">
                {partners.map(({ url, imgSrc, imgAlt }, index) => (
                    <li key={index} className={countPartners-1 == index ? "" : "mb-3"}>
                        <a href={url} target="_blank" title={imgAlt} className="d-block text-center">
                            <img src={imgSrc} alt={imgAlt} />
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default WidgetPartners;